<div class="mentions-legales-title">
  <h1>
    MENTIONS LÉGALES ET CRÉDITS
  </h1>
  <p>
    <b>ANETT</b> est à votre disposition pour toutes remarques ou suggestions.
  </p>
</div>

<div class="mentions-legales">
  <div class="mentions-legales-column">
    <h2>
      GESTION EDITORIALE
    </h2>

    <p>
      <b>ANETT</b><br>
      <b>Siège Social</b><br>
      2 rue de la Mairie<br>
      Vrines<br>
      79100 THOUARS<br>
      Tél. 05 49 68 18 12<br>
      Fax : 05 49 96 17 96<br>
      anettetcie&#64;anett.fr
    </p>

    <h2>
      DIRECTEUR DE PUBLICATION
    </h2>
    <p>
      <b>ANETT</b>
    </p>

    <h2>
      CRÉATION ET CONCEPTION DU SITE INTERNET
    </h2>
    <p>
      Toutes les coordonnées concernant la création du site internet sont disponibles via le lien suivant :
      SPIKEELABS : https://spikeelabs.fr
    </p>

    <h2>
      DROITS ET DEVOIRS DES UTILISATEURS
    </h2>
    <p>
      Les informations diffusées sur ce site sont la propriété de <b>ANETT</b>.<br>
      Toute copie totale ou partielle ne peut se faire sans l'accord de <b>ANETT</b>. Les utilisateurs sont responsables
      des interrogations qu'ils formulent ainsi que de l'interprétation et de l'utilisation qu'ils font des résultats.
      Il
      leur appartient d'en faire un usage conforme aux réglementations en vigueur et aux recommandations de la
      Commission
      Nationale de l'Informatique et des Libertés (CNIL) lorsque les données ont un caractère nominatif.<br>
      En particulier, ils doivent savoir que les informations ne doivent être utilisées qu'à des fins strictement
      personnelles, que la capture des écrans pour reconstitution ou enrichissement d'une base de données nominatives
      est
      contraire à la loi française et donc interdite, ainsi que l'utilisation à des fins commerciales ou
      publicitaires.<br>
    </p>
  </div>

  <div class="mentions-legales-column">
    <h2>
      DONNÉES PERSONNELLES
    </h2>
    <p>
      Conformément à la loi n° 2004-801 du 6 août 2004 relative à la protection des personnes physiques à l'égard des
      traitements de données à caractère personnel modifiant la loi n° 78-17 du 6 janvier 1978 , ce site a été déclaré
      auprès de la CNIL (déclaration n° 1967221 v0). Textes légaux (disponibles sur le site web de la CNIL : www.cnil.fr
      )
      loi nº 78-17 du 6 janvier 1978, relative à l'informatique, aux fichiers et aux libertés, dite loi Informatique et
      Libertés, Délibération de la CNIL nº 81-94 du 21 juillet 1981 portant adoption d'une recommandation relative aux
      mesures générales de sécurité des systèmes informatiques, loi nº 88-19 du 5 janvier 1988 relative à la fraude
      informatique, dite loi Godfrain.
    </p>

    <h2>
      LIENS
    </h2>
    <p>
      La mise en place de liens hypertextes par des tiers vers des pages ou des documents diffusés sur ce site, pouvant
      de
      fait constituer une atteinte aux droits d'auteur, un acte relevant du parasitisme ou de la diffamation, elle doit
      faire l'objet d'une autorisation de la société <b>ANETT</b> qui peut être sollicitée directement auprès de
      l'administrateur du site.<br>
      L'autorisation correspondante sera accordée si les liens ne contreviennent pas aux intérêts de <b>ANETT</b>, et,
      s'ils garantissent la possibilité pour l'utilisateur d'identifier l'origine <b>ANETT</b> sur le document,
      notamment
      dans le cas de liens hypertextes profonds, de cadrage ou d'insertion par liens.<br>
      De même, <b>ANETT</b> a sollicité par écrit l'autorisation de créer des liens vers son site de la part de tous les
      serveurs indiqués : les informations restent la propriété pleine et entière de ces serveurs et ne sauraient
      engager
      la responsabilité de la société de quelconque manière.<br>
    </p>

    <h2>
      DROIT APPLICABLE
    </h2>
    <p>
      Les présentes mentions légales sont soumises au droit interne français. La langue des mentions légales est la
      langue
      française. En cas de litige, les tribunaux français seront seuls compétents.
    </p>
  </div>
</div>




<div class="mentions-legales">
  <div class="mentions-legales-column">
    <h2>CRÉDITS</h2>
    <p>
      L'ensemble des contenus (photos, textes, vidéo, son…) consultables sur ce site demeure la propriété exclusive
      d'<b>ANETT</b> et/ou de ses partenaires et relève de la législation française sur le droit d'auteur et la
      propriété
      intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les
      représentations iconographiques et photographiques.<br>
      Toute extraction et/ou reproduction d'une partie substantielle des informations diffusées sur le site est
      interdite
      sans l'autorisation préalable d'<b>ANETT</b> et constitue une contrefaçon sanctionnée par les articles L.335-2 et
      suivants du Code de la propriété intellectuelle.<br>
      Le code de la Propriété Intellectuelle précise qu'il faut citer la source ou demander l'autorisation de l'auteur
      des
      images. Il ne joue que dans le cadre du respect du droit d'auteur. En tant que création de l'esprit, les images
      (même les copies d'écran) sont donc protégées par le droit d'auteur (art. L112-2-9 du Code de Propriété
      Intellectuelle).<br>
      Le fait de reproduire ou de représenter, sans autorisation, des images, textes ou documents est punissable sur le
      plan civil par une condamnation à des dommages et intérêts. Ces dommages et intérêts sont calculés au cas par cas.
      Cela dépend du manque à gagner de la victime, du préjudice subi dû à la dénaturation de la façon dont est présenté
      le site et des répercussions qu'a pu en avoir l'auteur du site, de la façon dont l'image a été mise en avant et de
      celle qu'elle a pu rapporter éventuellement en termes financiers au concepteur.<br>
    </p>
  </div>

  <div class="mentions-legales-column">
    <h2>
      CRÉDITS PHOTOS
    </h2>
    <p>
      <b>ANETT</b><br>
      <b>Siège Social</b><br>
      2 rue de la Mairie<br>
      Vrines<br>
      79100 THOUARS<br>
      Tél. 05 49 68 18 12<br>
      Fax : 05 49 96 17 96<br>
      anettetcie&#64;anett.fr<br>
    </p>
  </div>
</div>